export const mockQuestions = [
  {
    id: 33,
    question: 'After an audit, an administrator discovers all users have access to confidential data on a file server. Which of the following should the administrator use to restrict access to the data quickly?',
    options: [
      'Group Policy',
      'Content filtering',
      'Data loss prevention',
      'Access control lists'
    ],
    answer: 'd. Access control lists',
    subject: 'Cybersecurity'
  },
  {
    id: 34,
    question: 'A company is decommissioning its physical servers and replacing them with an architecture that will reduce the number of individual operating systems. Which of the following strategies should the company use to achieve this security requirement?',
    options: [
      'Microservices',
      'Containerization',
      'Virtualization',
      'Infrastructure as code'
    ],
    answer: 'c. Virtualization',
    subject: 'Cybersecurity'
  },
  {
    id: 35,
    question: "A visitor plugs a laptop into a network jack in the lobby and is able to connect to the company's network. Which of the following should be configured on the existing network infrastructure to best prevent this activity?",
    options: [
      'Port security',
      'Web application firewall',
      'Transport layer security',
      'Virtual private network'
    ],
    answer: 'a. Port security',
    subject: 'Cybersecurity'
  },
  {
    id: 36,
    question: 'Which of the following is classified as high availability in a cloud environment?',
    options: [ 'Access broker', 'Cloud HSM', 'WAF', 'Load balancer' ],
    answer: 'd. Load balancer',
    subject: 'Cybersecurity'
  },
  {
    id: 37,
    question: 'Which of the following incident response activities ensures evidence is properly handled?',
    options: [ 'Ediscovery', 'Chain of custody', 'Legal hold', 'Preservation' ],
    answer: 'b. Chain of custody',
    subject: 'Cybersecurity'
  },
  {
    id: 38,
    question: 'Which of the following automation use cases would best enhance the security posture of an organization by rapidly updating permissions when employees leave a company?',
    options: [
      'Provisioning resources',
      'Disabling access',
      'Reviewing change approvals',
      'Escalating permission requests'
    ],
    answer: 'b. Disabling access',
    subject: 'Cybersecurity'
  },
  {
    id: 39,
    question: 'A company wants to verify that the software the company is deploying came from the vendor the company purchased the software from. Which of the following is the best way for the company to confirm this information?',
    options: [
      'Validate the code signature',
      'Execute the code in a sandbox',
      'Search the executable for ASCII strings',
      'Generate a hash of the files'
    ],
    answer: 'a. Validate the code signature',
    subject: 'Cybersecurity'
  },
  {
    id: 40,
    question: 'A security administrator identifies an application that is storing data using MD5. Which of the following best identifies the vulnerability likely present in the application?',
    options: [ 'Cryptographic', 'Malicious update', 'Zero day', 'Side loading' ],
    answer: 'a. Cryptographic',
    subject: 'Cybersecurity'
  },
  {
    id: 41,
    question: 'A user is attempting to patch a critical system, but the patch fails to transfer. Which of the following access controls is most likely inhibiting the transfer?',
    options: [ 'Attributebased', 'Time of day', 'Rolebased', 'Least privilege' ],
    answer: 'd. Least privilege',
    subject: 'Cybersecurity'
  },
  {
    id: 42,
    question: 'After performing an assessment, an analyst wants to provide a risk rating for the findings. Which of the following concepts should most likely be considered when calculating the ratings?',
    options: [
      'Owners and thresholds',
      'Impact and likelihood',
      'Appetite and tolerance',
      'Probability and exposure factor'
    ],
    answer: 'b. Impact and likelihood',
    subject: 'Cybersecurity'
  },
  {
    id: 43,
    question: 'Which of the following actions could a security engineer take to ensure workstations and servers are properly monitored for unauthorized changes and software?',
    options: [
      'Configure all systems to log scheduled tasks',
      'Collect and monitor all traffic exiting the network',
      'Block traffic based on known malicious signatures',
      'Install endpoint management software on all systems'
    ],
    answer: 'd. Install endpoint management software on all systems',
    subject: 'Cybersecurity'
  },
  {
    id: 44,
    question: 'Which of the following is used to validate a certificate when it is presented to a user?',
    options: [ 'OCSP', 'CSR', 'CA', 'CRC' ],
    answer: 'a. OCSP',
    subject: 'Cybersecurity'
  },
  {
    id: 45,
    question: 'Which of the following can be used to identify potential attacker activities without affecting production servers?',
    options: [ 'Honey pot', 'Video surveillance', 'Zero Trust', 'Geofencing' ],
    answer: 'a. Honey pot',
    subject: 'Cybersecurity'
  },
  {
    id: 46,
    question: 'Employees in the research and development business unit receive extensive training to ensure they understand how to best protect company data. Which of the following is the type of data these employees are most likely to use in daytoday work activities?',
    options: [
      'Encrypted',
      'Intellectual property',
      'Critical',
      'Data in transit'
    ],
    answer: 'b. Intellectual property',
    subject: 'Cybersecurity'
  },
  {
    id: 47,
    question: 'Visitors to a secured facility are required to check in with a photo ID and enter the facility through an access control vestibule. Which of the following best describes this form of security control?',
    options: [ 'Physical', 'Managerial', 'Technical', 'Operational' ],
    answer: 'a. Physical',
    subject: 'Cybersecurity'
  },
  {
    id: 48,
    question: 'Which of the following provides the details about the terms of a test with a thirdparty penetration tester?',
    options: [
      'Rules of engagement',
      'Supply chain analysis',
      'Right to audit clause',
      'Due diligence'
    ],
    answer: 'a. Rules of engagement',
    subject: 'Cybersecurity'
  },
  {
    id: 49,
    question: "A company's legal department drafted sensitive documents in a SaaS application and wants to ensure the documents cannot be accessed by individuals in highrisk countries. Which of the following is the most effective way to limit this access?",
    options: [
      'Data masking',
      'Encryption',
      'Geolocation policy',
      'Data sovereignty regulation'
    ],
    answer: 'c. Geolocation policy',
    subject: 'Cybersecurity'
  },
  {
    id: 50,
    question: 'Which of the following is the best way to consistently determine on a daily basis whether security settings on servers have been modified?',
    options: [
      'Automation',
      'Compliance checklist',
      'Attestation',
      'Manual audit'
    ],
    answer: 'a. Automation',
    subject: 'Cybersecurity'
  },
  {
    id: 51,
    question: 'An employee clicked a link in an email from a payment website that asked the employee to update contact information. The employee entered the login information but received a "page not found" error message. Which of the following types of social engineering attacks occurred?',
    options: [
      'Brand impersonation',
      'Pretexting',
      'Typosquatting',
      'Phishing'
    ],
    answer: 'd. Phishing',
    subject: 'Cybersecurity'
  },
  {
    id: 52,
    question: 'An organization is required to maintain financial data records for three years and customer data for five years. Which of the following data management policies should the organization implement? ---',
    options: [ 'Retention', 'Destruction', 'Inventory', 'Certification' ],
    answer: 'A. Retention',
    subject: 'Cybersecurity'
  },
  {
    id: 53,
    question: 'Which of the following would be the best way to block unknown programs from executing? ---',
    options: [
      'Access control list',
      'Application allow list',
      'Host-based firewall',
      'DLP solution'
    ],
    answer: 'B. Application allow list',
    subject: 'Cybersecurity'
  },
  {
    id: 54,
    question: 'An analyst is evaluating the implementation of Zero Trust principles within the data plane. Which of the following would be most relevant for the analyst to evaluate? ---',
    options: [
      'Secured zones',
      'Subject role',
      'Adaptive identity',
      'Threat scope reduction'
    ],
    answer: 'A. Secured zones',
    subject: 'Cybersecurity'
  },
  {
    id: 55,
    question: 'Which of the following best practices gives administrators a set period to perform changes to an operational system to ensure availability and minimize business impacts? ---',
    options: [
      'Impact analysis',
      'Scheduled downtime',
      'Backout plan',
      'Change management boards'
    ],
    answer: 'B. Scheduled downtime',
    subject: 'Cybersecurity'
  },
  {
    id: 56,
    question: 'An organization is leveraging a VPN between its headquarters and a branch location. Which of the following is the VPN protecting? ---',
    options: [
      'Data in use',
      'Data in transit',
      'Geographic restrictions',
      'Data sovereignty'
    ],
    answer: 'B. Data in transit',
    subject: 'Cybersecurity'
  },
  {
    id: 57,
    question: "An organization maintains intellectual property that it wants to protect. Which of the following concepts would be most beneficial to add to the company's security awareness training program? ---",
    options: [
      'Insider threat detection',
      'Simulated threats',
      'Phishing awareness',
      'Business continuity planning'
    ],
    answer: 'A. Insider threat detection',
    subject: 'Cybersecurity'
  },
  {
    id: 58,
    question: 'Which of the following describes the process of concealing code or text inside a graphical image? ---',
    options: [
      'Symmetric encryption',
      'Hashing',
      'Data masking',
      'Steganography'
    ],
    answer: 'D. Steganography',
    subject: 'Cybersecurity'
  },
  {
    id: 59,
    question: 'Which of the following describes the category of data that is most impacted when it is lost? ---',
    options: [ 'Confidential', 'Public', 'Private', 'Critical' ],
    answer: 'D. Critical',
    subject: 'Cybersecurity'
  },
  {
    id: 60,
    question: "A company tested and validated the effectiveness of network security appliances within the corporate network. The IDS detected a high rate of SQL injection attacks against the company's servers, and the company's perimeter firewall is at capacity. Which of the following would be the best action to maintain security and reduce the traffic to the perimeter firewall? ---",
    options: [
      'Set the appliance to IPS mode and place it in front of the company firewall',
      'Convert the firewall to a WAF and use IPSec tunnels to increase throughput',
      'Set the firewall to fail open if it is overloaded with traffic and send alerts to the SIEM',
      'Configure the firewall to perform deep packet inspection and monitor TLS traffic'
    ],
    answer: 'A. Set the appliance to IPS mode and place it in front of the company firewall',
    subject: 'Cybersecurity'
  },
  {
    id: 61,
    question: 'A security engineer needs to configure an NGFW to minimize the impact of the increasing number of various traffic types during attacks. Which of the following types of rules is the engineer the most likely to configure? ---',
    options: [
      'Signature-based',
      'Behavioral-based',
      'URL-based',
      'Agent-based'
    ],
    answer: 'B. Behavioral-based',
    subject: 'Cybersecurity'
  },
  {
    id: 62,
    question: "Which of the following practices would be best to prevent an insider from introducing malicious code into a company's development process? ---",
    options: [
      'Code scanning for vulnerabilities',
      'Open-source component usage',
      'Quality assurance testing',
      'Peer review and approval'
    ],
    answer: 'D. Peer review and approval',
    subject: 'Cybersecurity'
  },
  {
    id: 63,
    question: "Which of the following roles, according to the shared responsibility model, is responsible for securing the company's database in an IaaS model for a cloud environment? ---",
    options: [ 'Client', 'Third-party vendor', 'Cloud provider', 'DBA' ],
    answer: 'A. Client',
    subject: 'Cybersecurity'
  },
  {
    id: 64,
    question: "A client demands at least 99.99% uptime from a service provider's hosted security services. Which of the following documents includes the information the service provider should return to the client? ---",
    options: [ 'MOA', 'SOW', 'MOU', 'SLA' ],
    answer: 'D. SLA',
    subject: 'Cybersecurity'
  },
  {
    id: 65,
    question: 'Which of the following threat actors is the most likely to be hired by a foreign government to attack critical systems located in other countries? ---',
    options: [
      'Hacktivist',
      'Whistleblower',
      'Organized crime',
      'Unskilled attacker'
    ],
    answer: 'C. Organized crime',
    subject: 'Cybersecurity'
  },
  {
    id: 66,
    question: 'An engineer needs to find a solution that creates an added layer of security by preventing unauthorized access to internal company resources. Which of the following would be the best solution? ---',
    options: [ 'RDP server', 'Jump server', 'Proxy server', 'Hypervisor' ],
    answer: 'B. Jump server',
    subject: 'Cybersecurity'
  },
  {
    id: 67,
    question: 'A company must ensure sensitive data at rest is rendered unreadable. Which of the following will the company most likely use? ---',
    options: [ 'Hashing', 'Tokenization', 'Encryption', 'Segmentation' ],
    answer: 'C. Encryption',
    subject: 'Cybersecurity'
  },
  {
    id: 68,
    question: 'A company is planning a disaster recovery site and needs to ensure that a single natural disaster would not result in the complete loss of regulated backup data. Which of the following should the company consider? ---',
    options: [
      'Geographic dispersion',
      'Platform diversity',
      'Hot site',
      'Load balancing'
    ],
    answer: 'A. Geographic dispersion',
    subject: 'Cybersecurity'
  },
  {
    id: 69,
    question: 'A company is adding a clause to its AUP that states employees are not allowed to modify the operating system on mobile devices. Which of the following vulnerabilities is the organization addressing? ---',
    options: [
      'Cross-site scripting',
      'Buffer overflow',
      'Jailbreaking',
      'Side loading'
    ],
    answer: 'C. Jailbreaking',
    subject: 'Cybersecurity'
  },
  {
    id: 70,
    question: 'Which of the following must be considered when designing a high-availability network? (Select two) ---',
    options: [
      'Ease of recovery',
      'Ability to patch',
      'Physical isolation',
      'Responsiveness',
      'Attack surface',
      'Extensible authentication'
    ],
    answer: 'A. Ease of recovery and D. Responsiveness',
    subject: 'Cybersecurity'
  },
  {
    id: 71,
    question: 'Which of the following can best protect against an employee inadvertently installing malware on a company system? ---',
    options: [
      'Host-based firewall',
      'System isolation',
      'Least privilege',
      'Application allow list'
    ],
    answer: 'D. Application allow list',
    subject: 'Cybersecurity'
  },
  {
    id: 72,
    question: 'After a security awareness training session, a user called the IT help desk and reported a suspicious call. The suspicious caller stated that the Chief Financial Officer wanted credit card information in order to close an invoice. Which of the following topics did the user recognize from the training? ---',
    options: [
      'Insider threat',
      'Email phishing',
      'Social engineering',
      'Executive whaling'
    ],
    answer: 'C. Social engineering',
    subject: 'Cybersecurity'
  },
  {
    id: 73,
    question: "A company is expanding its threat surface program and allowing individuals to security test the company's internet-facing application. The company will compensate researchers based on the vulnerabilities discovered. Which of the following best describes the program the company is setting up? ---",
    options: [
      'Open-source intelligence',
      'Bug bounty',
      'Red team',
      'Penetration testing'
    ],
    answer: 'B. Bug bounty',
    subject: 'Cybersecurity'
  },
  {
    id: 74,
    question: 'Which part of the AAA security framework specifies the permissions and activities that a user is allowed to perform on the network? ---',
    options: [
      'Accounting',
      'Authentication',
      'Non-repudiation',
      'Authorization'
    ],
    answer: 'D. Authorization',
    subject: 'Cybersecurity'
  },
  {
    id: 75,
    question: "A security analyst scans a company's public network and discovers a host is running a remote desktop that can be used to access the production network. Which of the following changes should the security analyst recommend? ---",
    options: [
      'Changing the remote desktop port to a non-standard number',
      'Setting up a VPN and placing the jump server inside the firewall',
      'Using a proxy for web connections from the remote desktop server',
      'Connecting the remote server to the domain and increasing the password length'
    ],
    answer: 'B. Setting up a VPN and placing the jump server inside the firewall',
    subject: 'Cybersecurity'
  },
  {
    id: 76,
    question: 'Which of the following should a systems administrator use to ensure an easy deployment of resources within the cloud provider? ---',
    options: [
      'Software as a service',
      'Infrastructure as code',
      'Internet of Things',
      'Software-defined networking'
    ],
    answer: 'B. Infrastructure as code',
    subject: 'Cybersecurity'
  },
  {
    id: 77,
    question: 'During a penetration test, a vendor attempts to enter an unauthorized area using an access badge. Which of the following types of tests does this represent? ---',
    options: [ 'Defensive', 'Passive', 'Offensive', 'Physical' ],
    answer: 'D. Physical',
    subject: 'Cybersecurity'
  },
  {
    id: 78,
    question: 'Security controls in a data center are being reviewed to ensure data is properly protected and that human life considerations are included. Which of the following best describes how the controls should be set up? ---',
    options: [
      'Remote access points should fail closed',
      'Logging controls should fail open',
      'Safety controls should fail open',
      'Logical security controls should fail closed'
    ],
    answer: 'C. Safety controls should fail open',
    subject: 'Cybersecurity'
  },
  {
    id: 79,
    question: 'In order to strengthen a password and prevent a hacker from cracking it, a random string of 36 characters was added to the password. Which of the following best describes this technique? ---',
    options: [ 'Key stretching', 'Tokenization', 'Data masking', 'Salting' ],
    answer: 'D. Salting',
    subject: 'Cybersecurity'
  },
  {
    id: 80,
    question: "A company prevented direct access from the database administrators' workstations to the network segment that contains database servers. Which of the following should a database administrator use to access the database servers? ---",
    options: [ 'Jump server', 'RADIUS', 'HSM', 'Load balancer' ],
    answer: 'A. Jump server',
    subject: 'Cybersecurity'
  },
  {
    id: 81,
    question: 'A security manager created new documentation to use in response to various types of security incidents. Which of the following is the next step the manager should take? ---',
    options: [
      'Set the maximum data retention policy',
      'Securely store the documents on an air-gapped network',
      "Review the documents' data classification policy",
      'Conduct a tabletop exercise with the team'
    ],
    answer: 'D. Conduct a tabletop exercise with the team',
    subject: 'Cybersecurity'
  },
  {
    id: 82,
    question: 'An organization would like to calculate the time needed to resolve a hardware issue with a server. Which of the following risk management processes describes this example? ---',
    options: [
      'Recovery point objective',
      'Mean time between failures',
      'Recovery time objective',
      'Mean time to repair'
    ],
    answer: 'D. Mean time to repair',
    subject: 'Cybersecurity'
  },
]

export function calculateTestResult(answered, flagged) {
  // Initialize counters and trackers
  const questions = mockQuestions;
  let correctCount = 0;
  let incorrectCount = 0;
  let unansweredCount = 0;
  let totalNegativeMarks = 0;
  const subjectPerformance = {};
  const subjectTotals = {};
  const subjectCorrect = {};

  // Process each question
  questions.forEach(question => {
    const questionId = question.id;
    const userAnswer = answered[questionId];
    const correctAnswer = question.answer.charAt(0).toLowerCase(); // Extract 'a', 'b', 'c', 'd'
    
    // Initialize subject tracking
    const subject = question.subject;
    if (!subjectTotals[subject]) {
      subjectTotals[subject] = 0;
      subjectCorrect[subject] = 0;
      subjectPerformance[subject] = { total: 0, correct: 0, percentage: 0 };
    }
    
    subjectTotals[subject]++;
    subjectPerformance[subject].total++;

    if (userAnswer === undefined) {
      unansweredCount++;
    } else {
      // Convert user answer (1,2,3,4) to letter (a,b,c,d)
      const userAnswerLetter = String.fromCharCode(96 + userAnswer); // 1->'a', 2->'b', etc.
      
      if (userAnswerLetter === correctAnswer) {
        correctCount++;
        subjectCorrect[subject]++;
        subjectPerformance[subject].correct++;
      } else {
        incorrectCount++;
        totalNegativeMarks += 0.25; // Assuming -0.25 for each wrong answer
      }
    }
  });

  // Calculate subject-wise percentages
  Object.keys(subjectPerformance).forEach(subject => {
    const performance = subjectPerformance[subject];
    performance.percentage = performance.total > 0 
      ? (performance.correct / performance.total) * 100 
      : 0;
  });

  // Calculate overall metrics
  const totalQuestions = questions.length;
  const totalAnswered = correctCount + incorrectCount;
  const accuracy = totalAnswered > 0 ? (correctCount / totalAnswered) * 100 : 0;
  const score = correctCount - totalNegativeMarks;

  // Identify strengths and weaknesses
  const strengths = [];
  const weaknesses = [];
  
  Object.keys(subjectPerformance).forEach(subject => {
    const percentage = subjectPerformance[subject].percentage;
    if (percentage >= 70) {
      strengths.push(subject);
    } else if (percentage <= 40) {
      weaknesses.push(subject);
    }
  });

  // Calculate percentile (using a simple method)
  const percentile = calculatePercentile(score, totalQuestions);

  return {
    score: Math.max(0, parseFloat(score.toFixed(2))),
    correct: correctCount,
    incorrect: incorrectCount,
    unanswered: unansweredCount,
    totalNegativeMarks: parseFloat(totalNegativeMarks.toFixed(2)),
    accuracy: parseFloat(accuracy.toFixed(2)),
    subjectWise: subjectPerformance,
    strengths,
    weaknesses,
    percentile: parseFloat(percentile.toFixed(2)),
    flaggedCount: flagged.size,
    totalQuestions
  };
}

// Helper function to calculate percentile
function calculatePercentile(userScore, totalQuestions) {
  // This is a simplified percentile calculation
  // In a real scenario, you might compare against historical data
  const maxPossibleScore = totalQuestions;
  const normalizedScore = (userScore / maxPossibleScore) * 100;
  
  // Using a basic percentile formula that assumes normal distribution
  // This can be replaced with more sophisticated methods
  if (normalizedScore >= 90) return 95;
  if (normalizedScore >= 80) return 85;
  if (normalizedScore >= 70) return 75;
  if (normalizedScore >= 60) return 65;
  if (normalizedScore >= 50) return 55;
  if (normalizedScore >= 40) return 45;
  if (normalizedScore >= 30) return 35;
  if (normalizedScore >= 20) return 25;
  if (normalizedScore >= 10) return 15;
  return 5;
}

// Alternative percentile calculation using z-score (more statistical)
function calculatePercentileAdvanced(userScore, meanScore = null, stdDev = null, totalQuestions) {
  // If no historical data, use a simple approach
  if (meanScore === null || stdDev === null) {
    return calculatePercentile(userScore, totalQuestions);
  }
  
  // Calculate z-score
  const zScore = (userScore - meanScore) / stdDev;
  
  // Convert z-score to percentile using approximation
  // This is a simplified version - in production, use a proper statistical library
  const percentile = 50 * (1 + erf(zScore / Math.sqrt(2))) * 100;
  return Math.max(0, Math.min(100, percentile));
}

// Error function approximation for normal distribution
function erf(x) {
  // Abramowitz and Stegun approximation
  const a1 =  0.254829592;
  const a2 = -0.284496736;
  const a3 =  1.421413741;
  const a4 = -1.453152027;
  const a5 =  1.061405429;
  const p  =  0.3275911;

  const sign = (x >= 0) ? 1 : -1;
  x = Math.abs(x);

  const t = 1.0 / (1.0 + p * x);
  const y = 1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);

  return sign * y;
}